export const configuration ={
    sizeperpage: 50,
    technicalsupevisorqtypermission:"Awaiting Confirmation"
}